import { FlexRow } from '@/components/common/Flex';
import { sp500ValueSeries } from '@common/data/sp500';
import styleguide from '@common/styleguide';
import { scaleTime } from '@visx/scale';
import { useMemo } from 'react';
import { scaleNumeric } from '../common/charts/chartHelper';
import LinePath from '../common/charts/shapes/LinePath';

let minValue = 0;
let maxValue = 0;
for (const datum of sp500ValueSeries) {
    minValue = Math.min(minValue, datum.value);
    maxValue = Math.max(maxValue, datum.value);
}
const yDomain = [minValue, maxValue];
const minDate = sp500ValueSeries[0].date;
const maxDate = sp500ValueSeries[sp500ValueSeries.length - 1].date;
const xDomain = [Date.parse(minDate), Date.parse(maxDate)];

function DashboardNoFEsChart({
    width,
    height,
    stroke = [
        styleguide.colors.grayLight2X,
        styleguide.colors.grayLightX,
        styleguide.colors.grayLight2X,
    ],
}: {
    width: number;
    height: number;
    stroke?: string[];
}) {
    const yScale = useMemo(() => {
        return scaleNumeric({ values: yDomain, height });
    }, [height]);
    const xScale = useMemo(() => {
        const range = [0, width];
        return scaleTime({ domain: xDomain, range });
    }, [width]);

    return (
        <FlexRow w={width} h={height}>
            <svg width={width} height={height}>
                <LinePath
                    data={sp500ValueSeries}
                    x={(d) => xScale(Date.parse(d.date))}
                    y={(d) => yScale(d.value)}
                    initial={{ pathLength: 0 }}
                    animate={{
                        pathLength: 1,
                        stroke,
                        strokeWidth: [1.25, 2.5, 1.25],
                    }}
                    transition={{
                        pathLength: {
                            duration: 4,
                            delay: 0,
                            ease: 'easeInOut',
                        },
                        stroke: {
                            repeat: Infinity,
                            delay: 2,
                            duration: 4,
                            ease: 'easeInOut',
                        },
                        strokeWidth: {
                            repeat: Infinity,
                            delay: 2,
                            duration: 4,
                            ease: 'easeInOut',
                        },
                    }}
                    animateD={false}
                />
            </svg>
        </FlexRow>
    );
}

export default DashboardNoFEsChart;
